// ----------------------------------------------------------------------
// Global Dashboard Translations - French
// ----------------------------------------------------------------------

export const globalDashboardFr = {
  global_dashboard: {
    // Page title
    page_title: 'Tableau de bord',

    // Welcome messages by role
    welcome: {
      owner: 'Gérez votre entreprise depuis ici',
      ambassador: 'Prêt à promouvoir des événements incroyables ?',
      referral: 'Découvrez de nouveaux événements à partager et à gagner',
      waiter: 'Gérons ces tables efficacement',
      default: 'Votre tableau de bord est prêt',
    },

    // Contextual info alerts
    context_info: {
      event_mode_title: 'Focus Gestion d\'Événements',
      event_mode_description: 'Vous êtes en mode gestion d\'événements. Basculez en mode restaurant ou studio de musique dans les paramètres si nécessaire.',
      restaurant_mode_title: 'Focus Gestion de Restaurant',
      restaurant_mode_description: 'Vous êtes en mode gestion de restaurant. Basculez en mode événement ou studio de musique dans les paramètres si nécessaire.',
      music_studio_mode_title: 'Focus Gestion de Studio de Musique',
      music_studio_mode_description: 'Vous êtes en mode gestion de studio de musique. Basculez en mode événement ou restaurant dans les paramètres si nécessaire.',
    },

    // Dashboard modules
    modules: {
      events_management: 'Gestion des Événements',
      events_description: 'Créez, gérez et suivez vos événements',
      organizations: 'Organisations',
      organizations_description: 'Gérez vos organisations et paramètres',
      restaurants: 'Restaurants',
      restaurants_description: 'Gérez les restaurants et les menus',
      music_studios: 'Studios de Musique',
      music_studios_description: 'Gérez les studios d\'enregistrement, réservations et sessions',
      network_team: 'Réseau & Équipe',
      network_team_description: 'Invitez des utilisateurs, gérez l\'équipe et suivez les parrainages',
      ambassador_events: 'Événements Ambassadeur',
      ambassador_events_description: 'Consultez et promouvez des événements en tant qu\'ambassadeur',
      my_events: 'Mes Événements',
      my_events_description: 'Suivez vos événements promus et vos gains',
      table_management: 'Gestion des Tables',
      table_management_description: 'Gérez les tables et commandes de restaurant',
    },

    // Quick actions
    quick_actions: {
      title: 'Actions Rapides',
      create_event: 'Créer un Événement',
      create_organization: 'Créer une Organisation',
      invite_team: 'Inviter une Équipe',
      search_events: 'Rechercher des Événements',
    },

    // Available modules section
    available_modules: 'Modules Disponibles',

    // Buttons
    buttons: {
      open: 'Ouvrir',
      manage: 'Gérer',
      copy_link: 'Copier le Lien',
      share: 'Partager',
      create_event: 'Créer un Événement',
      create_event_org: 'Créer une Org. d\'Événement',
      create_studio: 'Créer un Studio',
    },

    // Labels
    labels: {
      new: 'Nouveau',
      event_org: 'Org. Événement',
      studio: 'Studio',
    },

    // Enhanced events module
    events_module: {
      title: 'Gestion des Événements',
      recent_events: 'événements récents',
      click_to_manage: 'Cliquez pour tout gérer',
      no_recent_events: 'Aucun événement récent',
      click_to_create: 'Cliquez pour créer votre premier événement',
      create_first_event: 'Créez votre premier événement pour commencer',
      more_events: 'événements supplémentaires',
    },

    // Event organizations module
    event_orgs_module: {
      title: 'Organisations d\'Événements',
      recent_organizations: 'organisations récentes',
      no_organizations: 'Aucune organisation d\'événement pour l\'instant',
      create_first_org: 'Créez votre première organisation d\'événement',
      followers: 'abonnés',
    },

    // Music studios module
    music_studios_module: {
      title: 'Studios de Musique',
      recent_studios: 'studios récents',
      no_studios: 'Aucun studio de musique pour l\'instant',
      create_first_studio: 'Créez votre premier studio de musique',
      services: 'services',
    },

    // Invitation card
    invitation_card: {
      title: 'Inviter au Réseau',
      description: 'Partagez votre lien d\'invitation',
      your_link: 'Votre lien d\'invitation :',
      link_copied: 'Lien d\'invitation copié dans le presse-papiers !',
      link_copy_failed: 'Échec de la copie du lien',
      share_title: 'Rejoignez Mon Réseau',
      share_text: 'Rejoignez mon réseau et découvrez des événements incroyables !',
    },

    // Contacts card
    contacts_card: {
      title: 'Mes Contacts',
      description: 'Gérez vos contacts',
      access_list: 'Accédez à votre liste de contacts',
      add_new: 'Ajoutez de nouveaux contacts',
      send_messages: 'Envoyez des e-mails et des messages',
    },

    // Event status chips
    event_status: {
      upcoming: 'à venir',
      ongoing: 'en cours',
      past: 'passé',
    },

    // Mode chips
    mode: {
      event: 'Mode Événement',
      music_studio: 'Mode Studio de Musique',
      restaurant: 'Mode Restaurant',
    },

    // Footer
    footer: {
      help_text: 'Besoin d\'aide ? Consultez notre documentation ou contactez le support.',
    },
  },
};

export default globalDashboardFr;
